'use strict';

var pullPushable = require('pull-pushable');

var pullWrite = require('pull-write');

module.exports = function createBuildStream(createStrategy, _ipld, options) {
  var source = pullPushable();
  var sink = pullWrite(createStrategy(source), null, options.highWaterMark, function (err) {
    return source.end(err);
  });
  return {
    source: source,
    sink: sink
  };
};